import React, { useState } from "react";

const GradeCalculator = () => {
  const [assignments, setAssignments] = useState([{ score: "", weight: "" }]);
  const [finalGrade, setFinalGrade] = useState(null);

  const calculateGrade = () => {
    let totalWeight = assignments.reduce((acc, curr) => acc + parseFloat(curr.weight || 0), 0);
    let weightedSum = assignments.reduce((acc, curr) => acc + (parseFloat(curr.score || 0) * parseFloat(curr.weight || 0)), 0);
    
    setFinalGrade((weightedSum / totalWeight).toFixed(2));
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Grade Calculator</h2>
      {assignments.map((assignment, index) => (
        <div key={index} className="flex gap-2 mt-3">
          <input
            type="number"
            placeholder="Score"
            className="border p-2 w-1/2"
            onChange={(e) => {
              let newAssignments = [...assignments];
              newAssignments[index].score = e.target.value;
              setAssignments(newAssignments);
            }}
          />
          <input
            type="number"
            placeholder="Weight"
            className="border p-2 w-1/2"
            onChange={(e) => {
              let newAssignments = [...assignments];
              newAssignments[index].weight = e.target.value;
              setAssignments(newAssignments);
            }}
          />
        </div>
      ))}
      <button
        className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full"
        onClick={calculateGrade}
      >
        Calculate Grade
      </button>
      {finalGrade && (
        <div className="mt-3 text-center text-lg">
          Final Grade: <span className="font-bold text-green-600">{finalGrade}</span>
        </div>
      )}
    </div>
  );
};

export default GradeCalculator;
